var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
  'orange darken-3': _vm.$router.currentRoute.name === 'login'
    || _vm.$router.currentRoute.name === 'register'
},attrs:{"app":"","light":""}},[_c('notification'),_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"hold":_vm.loading}}),_c('free-notification'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }